import { render } from "./QueuesList.vue?vue&type=template&id=1b7b7f6a"
import script from "./QueuesList.vue?vue&type=script&lang=js"
export * from "./QueuesList.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__